// Cyborg Automation, ambient glow, scroll effects, reveal, ticker,
// scroll-progress rail, footer clock, dashboard-teaser build animation.

(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── Ambient page glow (injected once) ──────────────────────────────────
  if (!document.querySelector('.page-glow')) {
    const glow = document.createElement('div');
    glow.className = 'page-glow';
    glow.setAttribute('aria-hidden', 'true');
    glow.innerHTML =
      '<div class="page-glow__top"></div>' +
      '<div class="page-glow__bloom"></div>' +
      '<div class="page-glow__grain"></div>';
    document.body.prepend(glow);
  }

  // ── Scroll-progress rail across the very top, site-wide ────────────────
  if (!document.querySelector('.scroll-progress')) {
    const sp = document.createElement('div');
    sp.className = 'scroll-progress';
    sp.setAttribute('aria-hidden', 'true');
    sp.innerHTML = '<i></i>';
    document.body.appendChild(sp);
  }

  const progressBar = document.querySelector('.scroll-progress i');
  const bloom       = document.querySelector('.page-glow__bloom');
  const topGlow     = document.querySelector('.page-glow__top');
  const heroSection = document.querySelector('.cyborg-hero');
  const orb         = document.querySelector('.cyborg-hero__orb');
  const heroGrid    = document.querySelector('.cyborg-hero__grid');

  // ── Mouse parallax on the hero ─────────────────────────────────────────
  function onMove(e) {
    const x = (e.clientX / window.innerWidth  - 0.5);
    const y = (e.clientY / window.innerHeight - 0.5);
    if (orb)      orb.style.transform  = 'translate(calc(-50% + ' + (x * 40) + 'px), calc(-50% + ' + (y * 30) + 'px))';
    if (heroGrid) heroGrid.style.translate = (x * 12) + 'px ' + (y * 8) + 'px';
    if (bloom)    bloom.style.translate = (x * 18) + 'px 0';
  }
  if (heroSection && !reduceMotion) {
    window.addEventListener('mousemove', onMove, { passive: true });
  }

  // ── Scroll-reactive glow + nav state + progress rail ───────────────────
  function onScroll() {
    const y   = window.scrollY;
    const max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    const p   = Math.min(1, Math.max(0, y / max));
    const eased = 1 - Math.pow(1 - p, 2); // ease-out quad

    if (progressBar) progressBar.style.setProperty('--sp', p.toFixed(4));

    const nav = document.querySelector('.cyborg-nav');
    if (nav) nav.classList.toggle('scrolled', y > 30);

    if (bloom)   bloom.style.setProperty('--bloom-o',  (0.06 + eased * 0.30).toFixed(3));
    if (topGlow) topGlow.style.setProperty('--top-o',  (0.10 - p * 0.06).toFixed(3));
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // ── Reveal on scroll, single blocks + staggered groups ────────────────
  const io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });

  const toReveal = new Set();
  document.querySelectorAll('.reveal').forEach(function (el) { toReveal.add(el); });
  // Children of a [data-reveal-seq] container cascade in one after another
  document.querySelectorAll('[data-reveal-seq]').forEach(function (group) {
    Array.from(group.children).forEach(function (child, i) {
      child.style.setProperty('--reveal-delay', (Math.min(i, 14) * 70) + 'ms');
      toReveal.add(child);
    });
  });
  toReveal.forEach(function (el) { io.observe(el); });

  // ── Ticker: duplicate the track so it scrolls seamlessly ───────────────
  const ticker = document.querySelector('.cyborg-hero__ticker-track');
  if (ticker) {
    ticker.innerHTML += ticker.innerHTML;
  }

  // ── Footer live status, pulsing dot + local clock ─────────────────────
  const footBottom = document.querySelector('.cyborg-footer__bottom');
  if (footBottom && !footBottom.querySelector('.cyborg-footer__status')) {
    const st = document.createElement('span');
    st.className = 'cyborg-footer__status';
    st.innerHTML = '<i></i> LOCAL TIME · <time></time>';
    footBottom.insertBefore(st, footBottom.firstChild);
    const timeEl = st.querySelector('time');
    const two = function (n) { return String(n).padStart(2, '0'); };
    const tickClock = function () {
      const d = new Date();
      timeEl.textContent = two(d.getHours()) + ':' + two(d.getMinutes()) + ':' + two(d.getSeconds());
    };
    tickClock();
    setInterval(tickClock, 1000);
  }

  // ── Dashboard teaser: gentle 3D tilt toward the cursor ─────────────────
  const frame = document.querySelector('.dd-teaser__frame');
  if (frame && !reduceMotion) {
    const zone = frame.closest('.dd-teaser__mock') || frame;
    zone.addEventListener('mousemove', function (e) {
      const r  = frame.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width  - 0.5;
      const py = (e.clientY - r.top)  / r.height - 0.5;
      frame.style.setProperty('--tilt-y', (px * 5).toFixed(2) + 'deg');
      frame.style.setProperty('--tilt-x', (-py * 5).toFixed(2) + 'deg');
    });
    zone.addEventListener('mouseleave', function () {
      frame.style.setProperty('--tilt-x', '0deg');
      frame.style.setProperty('--tilt-y', '0deg');
    });
  }

  // ── Dashboard teaser: looping "build" sequence ─────────────────────────
  // The mock assembles itself card by card, as if unseen hands are sketching
  // the dashboard live: a glowing worker moves in, each card is drawn as a
  // wireframe, snaps solid with a spark, then the whole thing goes live for a
  // few beats before clearing and rebuilding.
  if (frame && !reduceMotion) {
    const grid   = frame.querySelector('.dd-teaser__grid');
    const cursor = frame.querySelector('.dd-teaser__cursor');
    const status = frame.querySelector('.dd-teaser__status');
    const meter  = frame.querySelector('.dd-teaser__progress b');
    const tiles  = Array.from(frame.querySelectorAll('.dd-tile'));

    if (grid && cursor && status && meter && tiles.length) {
      // plausible live-value drifts, keyed by card label
      const feeds = {};
      tiles.forEach(function (t) {
        const drift = t.getAttribute('data-drift');
        const name  = (t.querySelector('b') || {}).textContent || '';
        if (drift && name) {
          feeds[name] = drift.split('|').map(function (s) { return s.trim(); }).filter(Boolean);
        }
      });

      let timers  = [];
      let running = false;
      const wait  = function (ms) { return new Promise(function (res) { timers.push(setTimeout(res, ms)); }); };
      const clearTimers = function () { timers.forEach(clearTimeout); timers = []; };
      const nameOf = function (t) { return (t.querySelector('b') || {}).textContent || ''; };

      function moveCursorTo(tile) {
        const cx = tile.offsetLeft + tile.offsetWidth / 2;
        const cy = tile.offsetTop  + tile.offsetHeight / 2;
        cursor.style.transform = 'translate(' + cx + 'px,' + cy + 'px)';
      }

      function sparkle(tile) {
        const cx = tile.offsetLeft + tile.offsetWidth / 2;
        const cy = tile.offsetTop  + tile.offsetHeight / 2;
        const n = 7;
        for (let i = 0; i < n; i++) {
          const s = document.createElement('span');
          s.className = 'dd-spark';
          const a = (Math.PI * 2 * i) / n + Math.random() * 0.7;
          const d = 14 + Math.random() * 18;
          s.style.left = cx + 'px';
          s.style.top  = cy + 'px';
          s.style.setProperty('--dx', (Math.cos(a) * d).toFixed(1) + 'px');
          s.style.setProperty('--dy', (Math.sin(a) * d).toFixed(1) + 'px');
          grid.appendChild(s);
          timers.push(setTimeout(function () { s.remove(); }, 720));
        }
      }

      const idleLabel = status.getAttribute('data-idle') || 'HOME · GOOD EVENING';

      async function cycle() {
        // ---- reset: clear back to an empty wireframe canvas ----
        grid.querySelectorAll('.dd-spark').forEach(function (s) { s.remove(); });
        grid.classList.add('is-building');
        status.classList.add('is-building');
        cursor.classList.remove('is-active');
        tiles.forEach(function (t) {
          t.classList.remove('is-sketch', 'is-built');
          t.classList.add('is-slot');
          const sp = t.querySelector('span');
          if (sp) sp.classList.remove('is-updating');
        });
        meter.style.width = '0%';
        status.textContent = 'READING YOUR ROOMS';
        await wait(700); if (!running) return;

        // ---- place each card ----
        moveCursorTo(tiles[0]);
        cursor.classList.add('is-active');
        await wait(260); if (!running) return;

        for (let i = 0; i < tiles.length; i++) {
          const tile = tiles[i];
          moveCursorTo(tile);
          await wait(i === 0 ? 260 : 400); if (!running) return;
          tile.classList.remove('is-slot');
          tile.classList.add('is-sketch');
          status.textContent = 'DRAWING · ' + nameOf(tile);
          await wait(410); if (!running) return;
          tile.classList.remove('is-sketch');
          tile.classList.add('is-built');
          sparkle(tile);
          meter.style.width = Math.round(((i + 1) / tiles.length) * 100) + '%';
          await wait(290); if (!running) return;
        }

        // ---- settle: hand off, go live ----
        cursor.classList.remove('is-active');
        grid.classList.remove('is-building');
        status.classList.remove('is-building');
        status.textContent = idleLabel;
        await wait(950); if (!running) return;

        // ---- live: a few gentle value drifts ----
        const labels = Object.keys(feeds);
        if (labels.length) {
          for (let k = 0; k < 5; k++) {
            const label = labels[Math.floor(Math.random() * labels.length)];
            const tile  = tiles.find(function (t) { return nameOf(t) === label; });
            const span  = tile && tile.querySelector('span');
            if (span) {
              span.classList.add('is-updating');
              await wait(300); if (!running) return;
              const vals = feeds[label];
              let next = span.textContent;
              while (next === span.textContent && vals.length > 1) {
                next = vals[Math.floor(Math.random() * vals.length)];
              }
              span.textContent = next;
              span.classList.remove('is-updating');
            }
            await wait(620); if (!running) return;
          }
        } else {
          await wait(2200); if (!running) return;
        }

        // ---- teardown: cards lift away, then rebuild ----
        status.classList.add('is-building');
        status.textContent = 'RE-SKETCHING';
        grid.classList.add('is-building');
        tiles.slice().reverse().forEach(function (t, idx) {
          timers.push(setTimeout(function () {
            t.classList.remove('is-built');
            t.classList.add('is-slot');
          }, idx * 85));
        });
        await wait(tiles.length * 85 + 450); if (!running) return;
        cycle();
      }

      const start = function () { if (!running) { running = true; cycle(); } };
      const stop  = function () { running = false; clearTimers(); };

      // run only while the mock is actually on screen
      const teaserIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
      }, { threshold: 0.3 });
      teaserIO.observe(frame);
    }
  }
})();
